import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ApplicationRef, ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { LocationService } from '../services/location.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as mapboxgl from 'mapbox-gl';

import Noty from 'noty';
import { EmojiServiceService } from '../services/emoji-service.service';
import { GeoService } from '../services/geo.service';
import { GameService } from '../services/game.service';
import * as turf from '@turf/turf';
declare let L;
import Swal from "sweetalert2";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WalkthroughModalComponent } from '../components/walkthroughModal/walkthroughModal.component';
import { UtilsService } from '../services/utils.service';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { LocaleService } from '../services/locale.service';
import { StorageService } from '../services/storage.service';
import * as PubNub from 'PubNub';
import { Subject } from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { SoundService } from '../services/audio.service';
import { MarkerIconService } from '../services/marker-icon.service';



@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
})
export class GameComponent implements OnInit, AfterViewInit {
  @ViewChild('scanner', { static: false }) scanner: ZXingScannerComponent;
  @ViewChild('camCorderModal', { static: false }) camCorderModal;
  @ViewChild('textInput', { static: false }) textInputModal: any;
  hasDevices: boolean;
  hasPermission: boolean;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo;
  pubnub;
  dynamic_url;
  isNotesImageCheck = false;
  bgColor1;
  playerRanking = 0;
  currentCardIndex = 0;
  notPositioned = false;
  gameCountdown;
  inactivityCountdown;
  playerSynch;
  otherPlayerSynch;
  battleCircleCountdown;
  geoLocationWatch;
  mapStyle = 'mapbox://styles/ercseypeter1/ckksgqro810vr17ord4zmvbum';
  swiperConfig = {
    spaceBetween: 10,
    loop: false,
    slidesPerView: 2,
    loopedSlides: true,
    centeredSlides: false,
  };
  imageComment: any;
  perks = [
    {
      name: 'freeze',
      description: 'You can freeze all players for 30 seconds',
      image: './assets/images/emoji/ice.png',
      teamPerk: true,
      date: new Date(),
      point: 100,
      defaultPoint: 100,
      used: null,
    },
    {
      name: 'double',
      image: './assets/images/emoji/slot.png',
      description: 'Double your points at the next question',
      point: 100,
      date: new Date(),
      defaultPoint: 100,
      used: null,
    },
  ];
  activeLayers = [];
  messageHistory = [];
  previewImage;
  currentCard: any;
  firstGameNoteRun = true;
  activeLevel = 1;
  pageConfig = {
    showQrReader: false,
    playerId: null,
    remainingMinutes: 0,
    center: [-74.2605542, 40.6971478],
    zoom: [12],
    lastPositionRefresh: moment(),
    remainingSentSlots: null,
    initialQuestion: false,
    showcaseIsActive: false,
  };
  loaders = {
    getPosition: false,
  };
  museumPlayers = [];
  activeBounds = [];
  availableGifs = [];
  activePerks = {
    bomb: false,
    blank_map: false,
  };
  createdBombPerkBy;
  map;
  passedNotifications = [];
  passedTimedQuestion = [];

  nearbyQuest: any = null;

  gameNotes = [];


  locales = {
    questionsAnswered: this.localeService.getTrans('questions answered'),
    remainingQuestions: this.localeService.getTrans('remaining questions'),
  }

  isImageUploading = false;

  currentCardObj = null;

  imageMessage = '';
 
  textInputValue = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private locationService: LocationService,
    public emojiService: EmojiServiceService,
    private appRef: ApplicationRef,
    public geoService: GeoService,
    public gameService: GameService,
    private ngZone: NgZone,
    private modalService: NgbModal,
    public utilsService: UtilsService,
    private changeDetectorRef: ChangeDetectorRef,
    public localeService: LocaleService,
    private storageService: StorageService,
    private cd: ChangeDetectorRef,
    private location: LocationStrategy,
    private audioService: SoundService,
    public markerIconService: MarkerIconService
  ) {
    this.perks = [
      {
        name: 'freeze',
        description: this.localeService.getTrans(
          'You can freeze all players for 30 seconds'
        ),
        image: './assets/images/emoji/ice.png',
        teamPerk: true,
        date: new Date(),
        point: 100,
        defaultPoint: 100,
        used: null,
      },
      {
        name: 'double',
        image: './assets/images/emoji/slot.png',
        description: this.localeService.getTrans(
          'Double your points at the next question'
        ),
        point: 100,
        date: new Date(),
        defaultPoint: 100,
        used: null,
      },
    ];

   
  

    /*  history.pushState(null, null, window.location.href);  
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });   */

    this.gameService.geoServiceSubject$.subscribe((val: any) => {
      if (val && val.bomb) {
        this.activePerks.bomb = false;
        this.http
          .post(environment.baseUrl + 'games/markBombPassed', {
            gameId: this.gameService.pageConfig.g,
            playerId: this.route.snapshot.paramMap.get('p'),
            createdBombPerkBy: this.createdBombPerkBy,
          })
          .subscribe((data: any) => {
            this.createdBombPerkBy = null;
            this.changeDetectorRef.detectChanges();
          });
      }
    });

    this.geoService.proximityStateChanged$.subscribe(() => {
      this.ngZone.run(() => this.updateNearbyQuestButton());
    });

    if (
      this.route.snapshot.paramMap.get('g') &&
      this.route.snapshot.paramMap.get('p')
    ) {
      this.pageConfig.playerId = this.route.snapshot.paramMap.get('p');
      if (this.route.snapshot.paramMap.get('inGame')) {
        this.pageConfig.initialQuestion = true;
      }
      this.gameService.pageConfig.g = this.route.snapshot.paramMap.get('g');
      this.gameService.pageConfig.p = this.route.snapshot.paramMap.get('p');

      if (this.locationService.isValidBrowser()) {
        this.getGame(
          this.route.snapshot.paramMap.get('g'),
          this.route.snapshot.paramMap.get('p'),
          true
        );
        //this.geoService.updateUser();
      }
    } else {
      this.navigateBack();
    }
  }

  openPopup(event: any, quest: any) {
    console.log('openPopup', quest);
  }

getGameQuests() {
  let quests;

  if (this.gameService.activeGame.tourId.isQR && this.gameService.me && this.gameService.me.passedQuests) {
    quests = _.map(_.filter(this.gameService.activeGame.quests, (q) => {
      return q.level === this.activeLevel && !q.isEndPOITimeline;
    }), (q1: any) => {
      return _.merge(q1, {
        isUpcoming: this.gameService.me.passedQuests.indexOf(q1._id) === -1
      });
    });
  } else {
    quests = _.map(_.filter(this.gameService.activeGame.quests, (q) => {
      return !q.isEndPOITimeline && !q.isTimedQuestion && q.isVisible;
    }), (q1: any) => {
      return _.merge(q1, {
        isUpcoming: this.gameService.me.passedQuests.indexOf(q1._id) === -1
      });
    });
  }

  // ✅ Only show next upcoming if sequence + showOnlyNext are true
  const tour = this.gameService.activeGame?.tourId;
  if (tour?.isSequenceGame  && tour?.isShowOnlyNextQuestion) {
    return quests.filter(q => q.isUpcoming).slice(0, 1);
  }

  return quests;
}

  trackByQuests(index, item) {
    return item._id + '_' + item.isUpcoming;
  }

  usesCustomMarkerIcon(quest: any): boolean {
    return this.markerIconService.usesCustomMarkerIcon(
      this.gameService.activeGame?.tourId,
      quest
    );
  }

  getCustomMarkerIconName(quest: any): string {
    return this.markerIconService.resolveCustomIconName(
      this.gameService.activeGame?.tourId,
      quest
    ) || '';
  }

  getMarkerPinFill(quest: any, fallback: string): string {
    return this.markerIconService.getPinFill(
      this.gameService.activeGame?.tourId,
      quest,
      fallback
    );
  }

  getCircleRadius() {
    let defaultRadius = 10;
    let q = this.gameService.activeGame.quests.length;
    if (q < 10) {
      return defaultRadius;
    } else if (q >= 10 && q < 15) {
      return defaultRadius;
    } else if (q >= 15 && q < 20) {
      return defaultRadius;
    } else if (q >= 20 && q < 25) {
      return defaultRadius + 5;
    } else if (q >= 25 && q < 30) {
      return defaultRadius + 15;
    } else {
      return defaultRadius + 50;
    }
  }

  getEndPoi() {
    return _.find(this.gameService.originalQuests, (x) => {
      return x.isEndPoi === true;
    });
  }

  getBattleCircleLineColor(): string {
    const proSettings = this.gameService.activeGame?.tourId?.battleCircleProSettings;
    if (this.gameService.activeGame?.tourId?.isBattleCirclePro && proSettings?.color) {
      return proSettings.color;
    }
    return '#627BC1';
  }

  drawCircle(isInit?) {
    if (
      this.gameService.activeGame.quests &&
      this.gameService.activeGame.quests.length
    ) {
      if (this.map) {
        if (this.map.getLayer('state-borders')) {
          this.map.removeLayer('state-borders');
          this.map.removeSource('state-borders');
        }
      }

      if (this.gameService.activeGame.quests) {
        let center;
        let radius;
        let circle;

        // Determine center point
        if (
          this.gameService.activeGame &&
          !this.gameService.activeGame.isEndPOI
        ) {
          center = this.getFeatureCenter();
          if (isInit) {
            this.pageConfig.center = [
              center.geometry.coordinates[0],
              center.geometry.coordinates[1],
            ];
          }
        } else {
          let endPoi = this.getEndPoi();
          center = { geometry: { coordinates: [endPoi.lng, endPoi.lat] } };
        }

        // Check if Battle Circle PRO is enabled
        const isBattleCirclePro = this.gameService.activeGame?.tourId?.isBattleCirclePro;
        const proSettings = this.gameService.activeGame?.tourId?.battleCircleProSettings;
        
        console.log('Battle Circle PRO check:', {
          isBattleCirclePro,
          proSettings,
          tourId: this.gameService.activeGame?.tourId
        });

        if (isBattleCirclePro && proSettings) {
          // Battle Circle PRO mode
          console.log('Battle Circle PRO mode activated');
          const totalMinutes = this.gameService.activeGame.tourId.length;
          const elapsedMinutes = totalMinutes - this.pageConfig.remainingMinutes;
          const progress = totalMinutes > 0 ? elapsedMinutes / totalMinutes : 0;

          // Calculate current radius based on speed characteristic
          const radiusMax = proSettings.radiusMax;
          const radiusMinValue = proSettings.radiusMin;
          
          console.log('PRO Settings:', {
            totalMinutes,
            elapsedMinutes,
            progress,
            radiusMax,
            radiusMinValue,
            speedCharacteristic: proSettings.speedCharacteristic
          });

          switch (proSettings.speedCharacteristic) {
            case 'accelerating':
              // Slow at start, fast at end (exponential)
              radius = radiusMax - ((radiusMax - radiusMinValue) * Math.pow(progress, 2));
              break;
            case 'decelerating':
              // Fast at start, slow at end (inverse exponential)
              radius = radiusMax - ((radiusMax - radiusMinValue) * (1 - Math.pow(1 - progress, 2)));
              break;
            case 'constant':
            default:
              // Linear shrinkage
              radius = radiusMax - ((radiusMax - radiusMinValue) * progress);
              break;
          }

          console.log('Calculated radius:', radius, 'km');

          // Draw the shrinking circle
          circle = turf.circle(center.geometry.coordinates, radius, {
            steps: 20,
            units: 'kilometers',
          });
          
          console.log('Circle drawn:', circle);

          // Set coordinates for the shrinking circle
          this.gameService.battleCircle.data.geometry.coordinates = [
            _.map(circle.geometry.coordinates[0], (x) => {
              return [x[0], x[1]];
            }),
          ];

        } else {
          // Standard Battle Circle mode
          radius = this.pageConfig.remainingMinutes / this.getCircleRadius();

          circle = turf.circle(center.geometry.coordinates, radius, {
            steps: 20,
            units: 'kilometers',
          });

          this.gameService.battleCircle.data.geometry.coordinates = [
            _.map(circle.geometry.coordinates[0], (x) => {
              return [x[0], x[1]];
            }),
          ];
        }
      }
    }
  }

  getFeatureCenter() {
    let features = [];
    let featuresTurf;
    _.forEach(this.gameService.activeGame.quests, (q) => {
      features.push([q.lng, q.lat]);
    });
    featuresTurf = turf.points(features);
    let center = turf.center(featuresTurf);
    return center;
  }

  dropPIN() {
    this.dropNoty(
      'info',
      this.localeService.getTrans('PIN to join the game: ') +
        this.gameService.activeGame.pin
    );
  }

  dropWalkthrough() {
    //this.router.navigate(['/walkthrough']);
    //const modalRef = this.modalService.open(WalkthroughModalComponent);
    //modalRef.componentInstance.mode = 'embed'
    this.clearIntervals();
    if (
      this.gameService.activeGame.partner &&
      this.gameService.activeGame.partner.isMuseum
    ) {
      this.router.navigate([
        '/museum-walkthrough',
        {
          g: this.gameService.activeGame._id,
          p: this.gameService.me.name,
          partner: this.gameService.activeGame.partner._id,
        },
      ]);
      this.gameService.activeGame = null;
    } else {
      this.router.navigate([
        '/walkthrough',
        {
          g: this.gameService.activeGame._id,
          p: this.gameService.me.name,
          m: 'embed',
        },
      ]);
    }
  }

  locateMe() {
    if (this.gameService.me && this.gameService.me.position && this.map) {
      this.map.flyTo({
        center: [
          this.gameService.me.position.lng,
          this.gameService.me.position.lat,
        ],
        duration: 0,
      });
      this.pageConfig.zoom =
        this.pageConfig.zoom[0] > 18 ? this.pageConfig.zoom : [18];
    }
  }

  refresh() {
    window.location.reload();
  }

  updateNearbyQuestButton() {
    if (
      this.geoService.modalActive ||
      (this.gameService.interimSettings.mapTapActive && !this.pageConfig.showcaseIsActive) ||
      !this.gameService.me?.position
    ) {
      this.nearbyQuest = null;
      return;
    }

    this.nearbyQuest = this.geoService.findNearbyAnswerableQuestion(
      this.gameService.me.position,
      this.activeLevel,
      this.pageConfig.showcaseIsActive
    );
    this.changeDetectorRef.detectChanges();
  }

  showNearbyQuestButton(): boolean {
    return !!(
      this.nearbyQuest &&
      (!this.gameService.activeGame?.tourId?.isQR || this.pageConfig.showcaseIsActive)
    );
  }

  onQuestMarkerClick(quest: any, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }

    if (this.pageConfig.showcaseIsActive || this.gameService.interimSettings.mapTapActive) {
      if (quest?.lng != null && quest?.lat != null) {
        this.gameService.me.position = {
          lng: quest.lng,
          lat: quest.lat,
        };
        this.ngZone.run(() => {
          this.geoService.isQuestionNearby(
            this.gameService.activeGame.quests,
            this.gameService.me.position,
            this.activePerks
          );
          this.updateNearbyQuestButton();
        });
      }
      return;
    }

    this.dropTooltip(
      './assets/images/pois/question-marker.png',
      'Question',
      'Answering questions earns you  ' + quest.points + ' points. Approach it to activate.'
    );
  }

  triggerNearbyQuestion() {
    if (!this.nearbyQuest || this.geoService.modalActive) {
      return;
    }

    this.geoService.questionDetected(this.nearbyQuest, null, this.activePerks);
    this.nearbyQuest = null;
  }

  mapClicked(event) {
    if (
      this.gameService.interimSettings.mapTapActive ||
      this.pageConfig.showcaseIsActive
    ) {
      if (event.lngLat) {
        const position = {
          lat: event.lngLat.lat,
          lng: event.lngLat.lng,
        };
        this.gameService.me.position = position;
        this.geoService.isQuestionNearby(
          this.gameService.activeGame.quests,
          position,
          this.activePerks
        );
        this.ngZone.run(() => {
          this.geoService.isQuestionNearby(
            this.gameService.activeGame.quests,
            position,
            this.activePerks
          );
          this.updateNearbyQuestButton();
        });
      }
    }
  }

  mins() {
    //this.pageConfig.remainingMinutes--;
    this.gameService.activeGame.tourId.length--;
  }

  scrollToContainer(id, player) {
    document.getElementById(id).scrollIntoView({
      behavior: 'smooth',
    });
    if (player.position && player.position.lng && player.position.lat) {
      this.pageConfig.center = [player.position.lng, player.position.lat];
      this.pageConfig.zoom = [18];
    }

    setTimeout((x) => {
      this.locateMe();
    }, 5000);
  }

  getLocationConstantly() {
    const options = {
      maximumAge: 3000,
      timeout: 5000,
      enableHighAccuracy: true,
    };
    if (this.geoLocationWatch) {
      navigator.geolocation.clearWatch(this.geoLocationWatch);
    }

    this.geoLocationWatch = navigator.geolocation.watchPosition(
      (object) => {
        if (!this.notPositioned && this.map) {
          this.notPositioned = true;
          this.map.flyTo({
            center: [object.coords.longitude, object.coords.latitude],
            duration: 0,
          });
        }
        if (
          !this.gameService.interimSettings.mapTapActive &&
          !this.pageConfig.showcaseIsActive
        ) {
          this.loaders.getPosition = true;
          this.gameService.me.position = {
            lat: object.coords.latitude,
            lng: object.coords.longitude,
          };

          this.ngZone.run(() => {
            if (this.geoService.canLookup) {
              this.geoService.isQuestionNearby(
                this.gameService.activeGame.quests,
                {
                  lat: object.coords.latitude,
                  lng: object.coords.longitude,
                },
                this.activePerks
              );
              //this.ping();
            }
            this.updateNearbyQuestButton();
          });

          //this.geoService.updateUser();

          this.loaders.getPosition = false;
        }
      },
      (error) => {
        this.loaders.getPosition = false;
        if (error && error.code === 1) {
          // Permission denied
          this.locationService.dropError();
        } else if (error && error.code === 2) {
          // Position unavailable (CoreLocation error)
          console.log('Location temporarily unavailable, retrying...');
          // Silently retry - don't show error to user as this is often temporary
        } else if (error && error.code === 3) {
          // Timeout
          this.dropNoty(
            'error',
            this.localeService.getTrans(
              'Getting location data takes more time than usual. Please wait for the map to initialize'
            ),
            null,
            5000
          );
          this.getLocationConstantly();
        }
      },
      options
    );
  }

  getLocation() {
    this.pageConfig.lastPositionRefresh = moment();
    this.loaders.getPosition = true;
    this.locationService.getPosition().then(
      (x: any) => {
        this.ngZone.run(() => {
          this.dropNoty(
            'success',
            this.localeService.getTrans('Position updated!')
          );

          this.gameService.me.position = {
            lat: x.coords.latitude,
            lng: x.coords.longitude,
          };
          this.updateNearbyQuestButton();
          this.geoService.isQuestionNearby(
            this.gameService.activeGame.quests,
            {
              lat: x.coords.latitude,
              lng: x.coords.longitude,
            },
            this.activePerks
          );
          this.pageConfig.center = [x.coords.longitude, x.coords.latitude];

          if (this.map.getZoom() < this.pageConfig.zoom) {
            this.pageConfig.zoom = [15];
          }

          // updateUserIfOK skips while an answer sync is in flight so we do not
          // queue a location-only updatePlayerOne right after wasCorrect.
          this.geoService.updateUserIfOK();
          this.loaders.getPosition = false;
        });
      },
      (err) => {
        this.ngZone.run(() => {
          this.loaders.getPosition = false;
          this.locationService.dropError();
        });
      }
    );
  }

  colorize() {
    if (
      this.gameService.activeGame &&
      this.gameService.activeGame.partner.color
    ) {
      let elems = document.querySelectorAll('.fi-map-control');
      Array.prototype.forEach.call(elems, (el) => {
        el.style.backgroundColor = this.bgColor1;
        el.style.borderColor = this.bgColor1;
      });
      elems = document.querySelectorAll('.flinkint-btn.primary');
      Array.prototype.forEach.call(elems, (el) => {
        el.style.backgroundColor = this.bgColor1;
        el.style.borderColor = this.bgColor1;
      });
      elems = document.querySelectorAll('.fi-game-card');
      Array.prototype.forEach.call(elems, (el) => {
        el.style.backgroundColor = this.bgColor1;
      });
    }
  }

  initGame() {
    setTimeout(() => {
      if (this.gameService.activeGame.tourId.isBattleCircle || this.gameService.activeGame?.tourId?.isBattleCirclePro) {
        this.drawCircle(true);
      }
    }, 3000);
  }

  refreshCircle() {
    // Todo calculate
    //3/90
  }

  terminateGameDueInactivity() {
    this.inactivityCountdown = setInterval(() => {
      const endTime = moment.duration(
        moment().diff(this.gameService.activeGame.startedDate)
      );

      if (endTime.asHours() > 12) {
        this.router.navigate([
          '/endGame',
          {
            c: 'timeout',
            g: this.route.snapshot.paramMap.get('g'),
            p: this.route.snapshot.paramMap.get('p'),
            groupId: this.gameService.activeGame.groupId,
          },
        ]);
      }
    }, 5000);
  }

  detectNotification(elapsedMinutes: number){
    if(this.gameService.activeGame.tourId.notifications?.length){
    const notification = _.find(this.gameService.activeGame.tourId.notifications, (n)=>{
      return n.minutes === elapsedMinutes;
    });
   
      if(notification && this.passedNotifications.indexOf(notification) === -1){
        this.dropNoty('info', notification.title + ' | ' + notification.description);
        this.passedNotifications.push(notification);
        this.messageHistory.push({
         time: moment().format('HH:mm'),
         message: {
          adminMessage: notification.description
         }
        });
      }
    }
      
  }

  detectTimedQuestion(elapsedMinutes: number) {
    if (this.gameService.activeGame.tourId.quests.filter((quest) => quest.isTimedQuestion).length) {
      const timedQuestion = _.find(
        this.gameService.activeGame.tourId.quests.filter((quest) => quest.isTimedQuestion),
        (n) => n.timeLimit === elapsedMinutes
      );
  
      if (timedQuestion && this.passedTimedQuestion.indexOf(timedQuestion) === -1) {
        const checkAndExecute = () => {
          if (this.geoService.modalActive) {
            return; // Exit and wait for the next interval
          }
  
          // If modalActive is false, perform the action and clear the interval
          clearInterval(retryInterval);
          this.geoService.questionDetected(timedQuestion, null, this.activePerks);
        };
  
        // Start retrying every 10 seconds
        const retryInterval = setInterval(checkAndExecute, 10000);
  
        // Run the check immediately before the first interval
        checkAndExecute();
      }
    }
  }
  

  startGameCountdown() {
    this.gameCountdown = setInterval(() => {
      this.compareTimeDifference();
    }, 1000);
    if (
      this.gameService.activeGame &&
      this.gameService.activeGame.tourId.isStory &&
      (this.gameService.activeGame.tourId.isBattleCircle || this.gameService.activeGame?.tourId?.isBattleCirclePro)
    ) {
      this.battleCircleCountdown = setInterval(() => {
        this.drawCircle();
      }, 5000);
    }
  }

  clearIntervals() {
    const interval_id = window.setInterval(function () {},
    Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }


  compareTimeDifference() {
    const endTime = moment(this.gameService.activeGame.startedDate).add(
      this.gameService.activeGame.tourId.length,
      'minutes'
    );

    const startTime = moment(this.gameService.activeGame.startedDate);
    const currentTime = moment();  // Get the current time
    const elapsedMinutes = currentTime.diff(startTime, 'minutes');

    console.log(this.gameService.activeGame.startedDate);
    console.log('elapsedMinutes', elapsedMinutes);

    this.detectNotification(elapsedMinutes);
    this.detectTimedQuestion(elapsedMinutes);

    if (!this.pageConfig.initialQuestion) {
      let qu = {
        question: this.localeService.getTrans('What is the goal of the game?'),
        type: '0',
        answers: [
          {
            _id: {
              $oid: 'ab1',
            },
            isTrue: true,
            answer: this.localeService.getTrans(
              'To collect all the story points'
            ),
          },
          {
            _id: {
              $oid: 'ab2',
            },
            isTrue: false,
            answer: this.localeService.getTrans('To wait until the time is up'),
          },
          {
            _id: {
              $oid: 'ab3',
            },
            isTrue: false,
            answer: this.localeService.getTrans(
              'To stay outside the battle circle'
            ),
          },
        ],
        time: 60,
        mediaUrl: null,
        _id: 'qmb123',
        points: 200,
      };
      if (this.gameService.me.passedQuests.indexOf(qu._id) === -1) {
        this.pageConfig.initialQuestion = true;
        this.geoService.questionDetected(qu, null, this.activePerks);
      } else {
        this.pageConfig.initialQuestion = true;
      }
    }

    this.pageConfig.remainingMinutes = Math.floor(
      moment.duration(endTime.diff(moment())).asMinutes()
    );

    /* if((Math.floor(moment.duration(this.pageConfig.lastPositionRefresh.diff(moment())).asSeconds())) < -60){
      this.pageConfig.lastPositionRefresh = moment();
      const element = document.querySelector('.animatebutton');
      element.classList.add('animated', 'swing');
      setTimeout(function() {
        element.classList.remove('swing');
      }, 1000);
      this.dropNoty('success', this.localeService.getTrans("Don't forget to use the 'Refresh my position' button regularly to refresh your current location in the game."))
    } */

    if (
      (this.pageConfig.remainingMinutes === 5 ||
        this.pageConfig.remainingMinutes === 10 ||
        this.pageConfig.remainingMinutes === 15) &&
      this.pageConfig.remainingSentSlots !== this.pageConfig.remainingMinutes
    ) {
      this.dropNoty(
        'info',
        this.localeService.getTrans('Hurry up, only ') +
          this.pageConfig.remainingMinutes +
          this.localeService.getTrans(' minutes left!')
      );
      this.pageConfig.remainingSentSlots = this.pageConfig.remainingMinutes;
    }

    if (this.pageConfig.remainingMinutes <= 0) {
      this.clearIntervals();
      navigator.geolocation.clearWatch(this.geoLocationWatch);
      this.geoService.endGame('timeout');
      //this.router.navigate(['/endGame', { c: 'timeout', g: this.route.snapshot.paramMap.get('g'), p: this.route.snapshot.paramMap.get('p') }]);
    }
  }

  dropPointInfoNoty(point) {
    if(point){
      this.dropNoty(
        'info',
        this.localeService.getTrans('This question will earn you') +
          ' ' +
          point + this.localeService.getTrans(' points if your answer is correct.')
      );
    }
    
  }

  dropNoty(type, text, clickEvent?, timeout?) {
    new Noty({
      type: type,
      text: text,
      killer: true,
      timeout,
      callbacks: {
        onClick: () => {
          if (clickEvent && clickEvent === 'safehouse') {
            this.pageConfig.center = [
              this.gameService.endQuest.coordinates[0],
              this.gameService.endQuest.coordinates[1],
            ];
            this.pageConfig.zoom = [22];
          } else{
            console.log('scrollDown')
            const element = document.querySelector("#message_history");
            if(element){
              element.scrollIntoView({ behavior: 'smooth', block: 'end'});
            }
          }
        },
      },
    }).show();
  }

  
  dropTooltip(image, title, text) {
  
    Swal.fire({
      imageUrl: image,
      title,
      text,
      showDenyButton: false,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`Got it`),
      confirmButtonColor: this.bgColor1,
      cancelButtonText: 'Back',
    });
  }

  // Handle marker click with navigation check
  handleMarkerClick(quest, image, title, text) {
    console.log('Marker clicked:', quest);
    
    // First, show the point notification if it's a question
    if (quest.isQuestion && quest.points) {
      this.dropPointInfoNoty(quest.points);
    }
    
    // Check if navigation is enabled
    if (this.gameService.activeGame?.tourId?.navigationEnabled) {
      console.log('Navigation enabled, showing navigation option');
      // Show modal with navigation option
      this.showTooltipWithNavigation(quest, image, title, text);
    } else {
      console.log('Navigation disabled, showing default tooltip');
      // Default behavior - just show tooltip
      this.dropTooltip(image, title, text);
    }
  }

  // Show tooltip with navigation option
  showTooltipWithNavigation(quest, image, title, text) {
    Swal.fire({
      imageUrl: image,
      title,
      text,
      showDenyButton: true,
      denyButtonText: this.localeService.getTrans('Navigate') || 'Navigate',
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans('Got it'),
      confirmButtonColor: this.bgColor1,
      denyButtonColor: '#3085d6',
      reverseButtons: false,
    }).then((result) => {
      if (result.isDenied) {
        // User clicked "Navigate" - show navigation confirmation
        this.showNavigationConfirmation(quest);
      }
    });
  }

  // Show navigation confirmation dialog
  showNavigationConfirmation(quest) {
    Swal.fire({
      icon: 'question',
      title: this.localeService.getTrans('Open Google Maps?') || 'Open Google Maps?',
      text: this.localeService.getTrans(
        'This will open Google Maps and navigate you away from the app. You\'ll need to switch back to Flinkit to continue playing the game.'
      ) || 'This will open Google Maps and navigate you away from the app. You\'ll need to switch back to Flinkit to continue playing the game.',
      showDenyButton: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans('Open Maps') || 'Open Maps',
      cancelButtonText: this.localeService.getTrans('Back'),
      confirmButtonColor: this.bgColor1,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // User clicked "Open Maps"
        this.openGoogleMapsNavigation(quest.lat, quest.lng);
      }
    });
  }

  // Open Google Maps with navigation to coordinates
  openGoogleMapsNavigation(lat: number, lng: number) {
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    
    // Try to open in a new window/tab
    const newWindow = window.open(mapsUrl, '_blank');
    
    // Fallback if popup was blocked
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      // Show a notification that popup was blocked
      Swal.fire({
        title: this.localeService.getTrans('Navigation') || 'Navigation',
        text: this.localeService.getTrans('Please allow popups to open Google Maps') || 'Please allow popups to open Google Maps',
        icon: 'info',
        confirmButtonText: this.localeService.getTrans('OK') || 'OK',
        confirmButtonColor: this.bgColor1,
      });
    }
  }
  clickedBackpack(item) {
    Swal.fire({
      imageUrl: item,
      title: this.localeService.getTrans('Backpack item'),
      text: this.localeService.getTrans(
        'This item may help you to solve the final riddle.'
      ),
      showDenyButton: false,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`Got it`),
      confirmButtonColor: this.bgColor1,
      cancelButtonText: this.localeService.getTrans('Back'),
    });

    //this.dropNoty('info','This item will be useful and the end of the game.')
  }
  refreshPosition() {}

  showPlayerInfo(player) {
    Swal.fire({
      imageUrl: this.emojiService
        .getEmojiByIndex(player.avatarIndex)
        .icon.toString(),
      title: player.name,
      confirmButtonColor: this.gameService.activeGame.partner
        ? this.gameService.activeGame.partner.color
        : null,
      text:
        player.name +
        this.localeService.getTrans(
          ' is a fellow player in the musesum who scored '
        ) +
        player.points +
        this.localeService.getTrans(' points so far.') +
        (!player.isFinished
          ? this.localeService.getTrans(' The player is still in the museum!')
          : ''),
      confirmButtonText: this.localeService.getTrans(`Got it`),
    });
  }

  checkMapTapPerk(users) {
    const otherPlayers = _.filter(users, (user) => {
      return user.name === this.pageConfig.playerId;
    });
    const perkEvents = _.orderBy(
      _.flatten(
        _.map(otherPlayers, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return perkEvent.type === 'map_tap';
          });
        })
      ),
      ['created'],
      ['desc']
    );

    if (perkEvents.length > 0) {
      let tm = moment.unix(perkEvents[0].created);

      if (Math.floor(moment.duration(tm.diff(moment())).asSeconds()) > -35) {
        this.gameService.interimSettings.mapTapActive = true;
      } else {
        this.gameService.interimSettings.mapTapActive = false;
      }
    }
  }

  checkFreezePerk(users) {
    const otherPlayers = _.filter(users, (user) => {
      return !user.isMe;
    });
    const perkEvents = _.orderBy(
      _.flatten(
        _.map(otherPlayers, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return perkEvent.type === 'freeze';
          });
        })
      ),
      ['created'],
      ['desc']
    );

    if (perkEvents.length > 0) {
      let tm = moment.unix(perkEvents[0].created);

      if (Math.floor(moment.duration(tm.diff(moment())).asSeconds()) > -35) {
        this.gameService.interimSettings.freezeActive = true;
      } else {
        this.gameService.interimSettings.freezeActive = false;
      }
    }
  }

  checkBombPerk(users) {
    const bombEvent = _.orderBy(
      _.flatten(
        _.map(users, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return (
              perkEvent.type === 'bomb' &&
              perkEvent.target === this.gameService.me.name &&
              perkEvent.isActive === true
            );
          });
        })
      ),
      ['created'],
      ['desc']
    );
    if (bombEvent.length) {
      this.activePerks.bomb = true;
      this.createdBombPerkBy = bombEvent[0].createdBy;
    } else {
      // Must clear — previously bomb stayed true forever after the first hit,
      // so every later correct answer was halved on the phone while admin still
      // counted full quest points ("From correct answers").
      this.activePerks.bomb = false;
    }
  }

  checkBlankMapPerk(users) {
    const otherPlayers = _.filter(users, (user) => {
      return !user.isMe;
    });
    const perkEvents = _.orderBy(
      _.flatten(
        _.map(otherPlayers, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return perkEvent.type === 'blank_map';
          });
        })
      ),
      ['created'],
      ['desc']
    );

    if (perkEvents.length > 0) {
      let tm = moment.unix(perkEvents[0].created);

      if (Math.floor(moment.duration(tm.diff(moment())).asSeconds()) > -35) {
        // this.mapStyle =
        //   'mapbox://styles/ercseypeter1/cl7hh0afu002m14qg80cjrff1';
        this.activePerks.blank_map = true;
      } else {
        //this.mapStyle = this.gameService.activeGame.tourId.style.mapStyle;
        this.activePerks.blank_map = false;
      }
    }
  }

  countPerks(type, points) {
    let perkEvents = _.filter(this.gameService.me?.perkEvents, (perkEvent) => {
      return perkEvent.type === type;
    });
    return perkEvents.length > 0 ? 1 : 1;
  } 

  synchOtherPlayers() {
    return this.http
      .post(environment.baseUrl + 'games/getOtherPlayers', {
        groupId: this.gameService.activeGame.groupId,
        playerId: this.gameService.me ? this.gameService.me._id : null,
        isDigitalMuseum: this.gameService.activeGame.partner
          ? this.gameService.activeGame.partner.isDigitalMuseum
          : null,
        partnerId: this.gameService.activeGame.partner
          ? this.gameService.activeGame.partner._id
          : null,
        tourId: this.gameService.activeGame.tourId._id,
      })
      .subscribe((data: any) => {
        _.remove(data.data, (d) => {
          return !d;
        });
        this.museumPlayers = _.orderBy(data.data, ['points'], ['desc']);
  
        if (data.success) {
          _.remove(data.data, (x) => {
            return !x;
          });
  
          const me = _.find(data.data, (x) => {
            return x.name === this.pageConfig.playerId;
          });
  
          if (me) {
            const photosChanged = this.gameService.hasValidatedPhotosChanged(
              this.gameService.me.photos,
              me.photos
            );

            if (photosChanged && me.photos) {
              this.gameService.me.photos = me.photos;
            }

            // Never clobber in-flight local quiz gains with a stale poll.
            // Only adopt remote points when higher (photo/host awards) or when
            // the server is ahead on answered quests.
            const remotePts = Number(me.points);
            const localPts = Number(this.gameService.me.points) || 0;
            const remotePassed = Array.isArray(me.passedQuests)
              ? me.passedQuests.length
              : 0;
            const localPassed = Array.isArray(this.gameService.me.passedQuests)
              ? this.gameService.me.passedQuests.length
              : 0;
            if (
              Number.isFinite(remotePts) &&
              (remotePts > localPts || remotePassed > localPassed)
            ) {
              this.gameService.me.points = remotePts;
            }
          }
  
          // Iterate through all players' photos to check for validation

            if (me?.photos && me.photos.length > 0) {
              const autoImageProcessing = this.gameService.activeGame.tourId.isAutoImageProcessing;
              let assignedImages = 0; // Counter for how many images have been assigned points

              console.log(autoImageProcessing, 'autoImageProcessing');
              me.photos.forEach((photo) => {
                
                if (photo.isValidated === true) {
                  const storedPhotoUrls = JSON.parse(localStorage.getItem('validatedPhotoUrls-'+this.gameService.me._id)) || [];
                  console.log('Stored photo URL checks:', storedPhotoUrls);
                  // Check if this photo URL has already been processed
                  if (!storedPhotoUrls.includes(photo.url)) {
                    console.log('its not stored')
                      // Drop a SweetAlert notification
                      this.dropValidatedImageNoty(photo);

                    // Store the URL in localStorage to avoid duplicate notifications
                    storedPhotoUrls.push(photo.url);
                    localStorage.setItem('validatedPhotoUrls-'+this.gameService.me._id, JSON.stringify(storedPhotoUrls));
                  }
                } else{
                  const storedPhotoUrls = JSON.parse(localStorage.getItem('validatedPhotoUrls-'+this.gameService.me._id)) || [];
                
                  // Check if this photo URL has already been processed
                  if (!storedPhotoUrls.includes(photo.url)) {
                   

                    if(autoImageProcessing && storedPhotoUrls.length < this.gameService.activeGame.tourId.autoImageProcessing.numberOfImages){
                      this.geoService.validateImage(this.gameService.activeGame.tourId.autoImageProcessing.points, photo.url);
                      
                      this.dropValidatedImageNoty({...photo, ...{
                        points: this.gameService.activeGame.tourId.autoImageProcessing.points
                      }});
                          // Store the URL in localStorage to avoid duplicate notifications
                    storedPhotoUrls.push(photo.url);
                    localStorage.setItem('validatedPhotoUrls-'+this.gameService.me._id, JSON.stringify(storedPhotoUrls));
                    } 
                
                }
              }
              });
            }
      
  
          _.remove(data.data, (x) => {
            return x.name === this.pageConfig.playerId;
          });
  
          const mapPlayers = _.cloneDeep(
            _.filter(data.data, (d) => {
              return !d.isFinished;
            })
          );
  
          this.gameService.enemyMarkers = mapPlayers.slice(0, 10);
          this.gameService.mapPlayers = mapPlayers;
  
          this.gameService.me.ranking = _.findIndex(
            _.orderBy(this.gameService.mapPlayers, ['points'], ['desc']),
            (r) => {
              return r.name === this.pageConfig.playerId;
            }
          );
  
          this.checkFreezePerk(data.data);
          this.checkMapTapPerk(this.museumPlayers);
          this.checkBlankMapPerk(data.data);
          this.checkBombPerk(data.data);
        }
      });
  }

  dropValidatedImageNoty(photo) {

    if(photo && photo.points){
      Swal.fire({
        title: this.localeService.getTrans('Photo Validated!'),
        text: this.localeService.getTrans('Your photo has been validated and you earned ') + photo.points + this.localeService.getTrans(' points.'),
        imageUrl: photo.url,
        imageAlt: 'Validated Photo'
      });
    } else{
      Swal.fire({
        title: this.localeService.getTrans('Photo Not Accepted'),
        text: this.localeService.getTrans('Unfortunately, we could not accept your photo.'),
        imageUrl: photo.url,
        imageAlt: 'Rejected Photo',
        icon: 'error'
      });
    }
  }


  initPubnub() {
    let id = _.find(this.gameService.activeGame.players, (p) => {
      return p.name.toLowerCase() === this.route.snapshot.paramMap.get('p').toLocaleLowerCase();
    });
    // game.players is often a stale embed without questionStatuses. Merge so we
    // keep local/user-doc progress instead of wiping statuses to [].
    if (id) {
      this.gameService.applyServerPlayer(id);
    }
    this.geoService.checkUserHasPaid(this.gameService.me);
    console.log('ITS ME', this.gameService.me);

    this.pubnub = new PubNub({
      publishKey: "pub-c-19cd6237-8998-4fcb-a001-a33dc293184f", //"pub-c-125b7199-434c-4139-8b37-3a36487c543d",
      subscribeKey: "sub-c-8b99f907-737b-40f5-bafd-ae82ab4cd196", //"sub-c-e07e43ee-5694-11eb-bf6e-f20b4949e6d2",
      uuid: (this.gameService.me && this.gameService.me._id) || id?._id,
    });

    this.subscribeForPubnub();
  }

  getPubnubHistory() {
    this.pubnub.fetchMessages(
      {
        channels: [this.gameService.activeGame.groupId],
        count: 100,
      },
      (status, response) => {
        if (
          response &&
          response.channels &&
          response.channels &&
          response.channels[this.gameService.activeGame.groupId]
        ) {
          this.messageHistory = _.map(
            response.channels[this.gameService.activeGame.groupId],
            (f) => {
              return {
                ...f,
                ...{ time: moment.unix(f.timetoken / 10000000).fromNow() },
              };
            }
          );
          this.reorderMessageHistory();
        }
      }
    );
  }

  subscribeForPubnub() {
    this.pubnub.addListener({
      message: (msg) => {
        this.updatePlayerAll(msg);
      },
    });
    this.pubnub.subscribe({
      channels: [this.gameService.activeGame.groupId],
    });
    this.getPubnubHistory();

    //this.ping();
  }

  reorderMessageHistory() {
    this.messageHistory = _.orderBy(
      this.messageHistory,
      ['timetoken'],
      ['desc']
    );
  }

  touchMap() {
    this.geoService.mapTouched = true;
  }

  updatePlayerAll(msg) {
    if (msg.message.adminMessage) {
      this.dropNoty('info', 'Admin: ' + msg.message.adminMessage);
      this.messageHistory.push({
        ...msg,
        ...{ time: moment.unix(msg.timetoken / 10000000).fromNow() },
      });
      this.reorderMessageHistory();
      this.geoService.vibrate();
    }

    /*   if(msg.message.player !== ('admin-' + this.gameService.activeGame._id)){
      this.gameService.activeGame.players.splice(_.findIndex(this.gameService.activeGame.players, {_id: msg.message.player}), 1, msg.message.payload);
      this.gameService.mapPlayers = _.filter(_.cloneDeep(this.gameService.activeGame.players), (y)=>{
        return y._id !== this.gameService.me._id;
      });
  
      if(msg.message.perks && msg.message.perks.length){      
        if(msg.message.perks[0] && msg.message.perks[0].created && msg.message.perks[0].creator !== this.route.snapshot.paramMap.get('p')){
          let tm = moment(msg.message.perks[0].created);
          if(msg.message.perks[0].name === 'freeze' && Math.floor(moment.duration(tm.diff(moment())).asSeconds())>-30){
            this.gameService.interimSettings.freezeActive = true;
          } else{
            this.gameService.interimSettings.freezeActive = false;
          }
        }
      }
  
      if(msg.message.type){
        if(msg.message.type === 1){
          this.geoService.endGame('direct')
          //this.endGame('direct');
        }
  
      }
  
      this.geoService.calculateRanking();
      this.cd.markForCheck();
    } else{
      if(msg.message.adminMessage){
        this.dropNoty('info', 'Admin: ' + msg.message.adminMessage);
      }
    } */
  }

  getRankingMapPlayers() {
    return _.orderBy(
      this.museumPlayers,
      [
        (o) => {
          return o.points;
        },
      ],
      ['desc']
    );
  }
  getRanking() {
    return _.orderBy(
      this.gameService.activeGame.players,
      [
        (o) => {
          return o.points;
        },
      ],
      ['desc']
    );
  }

  ping(type?) {
    let publishPayload = {
      channel: this.gameService.activeGame._id,
      message: {
        player: this.gameService.me._id,
        position: this.gameService.me.position,
        points: this.gameService.me.points,
        payload: this.gameService.me,
        perks: this.gameService.activeGame.teamPerks,
        type: type,
      },
    };
    if (this.pubnub) {
      this.pubnub.publish(publishPayload);
    }
  }

  synchPlayers() {
    this.initPubnub();
    if (!this.gameService.activeGame.tourId.isQR) {
      this.getLocationConstantly();
    }

    /*  return this.http.post(environment.baseUrl + 'games/getPlayers', {gameId: this.gameService.activeGame._id} ).subscribe((data: any) => {
      
       if(data.success){
         this.gameService.activeGame.players = data.data.players;
         this.gameService.mapPlayers = _.cloneDeep(data.data.players);
 
         
         let me = _.find(this.gameService.activeGame.players, (x) => {
             return (x.name === this.pageConfig.playerId);
         });
       
       
         this.perks = _.map(this.perks, (p)=>{
          
           return _.merge(p, {
             point: p.defaultPoint+(me.perkCounter*100)
           })
           
         })
 
         this.gameService.activeGame.quests = _.filter(this.gameService.activeGame.quests, (q)=>{
           return me.passedQuests.indexOf(q._id) === -1
         }) 
 
         // TODO (calculate that all players collected team points)
         // this.isTeamQuestSuccessful();
        
         _.remove(this.gameService.mapPlayers, (x) => {
           return (x.name === this.pageConfig.playerId);
         });
 
       
         // Igazából innentől kéne beépíteni
 
         if(!_.find(this.gameService.activeGame.quests, (q)=>{
           return q.questionType === 'story'
         })){
           if(!this.gameService.isPartnerGame){
             this.activateGameEndPOI();
           } else{
             if(_.filter(this.gameService.activeGame.quests, (quest)=>{return quest.isQuestion}).length === 0){
               this.endGame('end');
             }
           }
          f
         }
 
         if(_.filter(this.gameService.activeGame.quests, (quest)=>{return quest.isQuestion}).length === 0){
           this.endGame('end');
         }
 
          if((this.gameService.me.passedQuests.length <= me.passedQuests.length)){
           this.gameService.me = me;
         } 
        
         this.museumPlayers = _.orderBy(_.merge(this.museumPlayers, this.gameService.me), ['points'],['desc']);
        
         if(data.data.teamPerks && data.data.teamPerks.length){
         
           if(data.data.teamPerks[0] && data.data.teamPerks[0].created && data.data.teamPerks[0].creator !== this.route.snapshot.paramMap.get('p')){
             let tm = moment(data.data.teamPerks[0].created);
           
             if(data.data.teamPerks[0].name === 'freeze' && Math.floor(moment.duration(tm.diff(moment())).asSeconds())>-30){
               this.gameService.interimSettings.freezeActive = true;
             } else{
               this.gameService.interimSettings.freezeActive = false;
             }
           }
         
         }
 
         if(me.isFinished || this.gameService.activeGame.isFinished){
           this.endGame('endPoi');
         }
         this.gameService.me.ranking = _.findIndex(_.orderBy(this.gameService.activeGame.players, ['points'], ['desc']), (r)=>{
           return (r.name === this.pageConfig.playerId);
         })
 
         if(isInit){
          
 
           if(this.gameService.activeGame.indoorMode){
             this.initIndoorMode(this.gameService.activeGame.quests[0]);
           } else if(!this.gameService.activeGame.tourId.isQR){
 
             this.getLocationConstantly();
             //this.getLocation();
 
           }
              
         }
       } 
     });  */
  }
  isTeamQuestSuccessful() {}

  uploadImage() {
    this.modalService.dismissAll();

    this.isImageUploading = true;

    if (!this.previewImage.type.startsWith('image/')) {
      alert('Please upload a valid image.');
      return;
    }

 /*    if(this.currentCard){
      this.currentCard.isDisabled = true;
    } */
    
    const formData = new FormData();
    formData.append('file', this.previewImage);

    return this.http
      .post(environment.baseUrl + 'file-service/upload', formData)
      .subscribe((data: any) => {
        this.updateUserWithImageAndLocation(data.url);
        this.isImageUploading = false;
        this.dropNoty(
          'success',
          this.localeService.getTrans('Image successfully uploaded')
        );
        this.audioService.play('success');
      }, (err)=>{
        this.dropNoty(
          'error',
          this.localeService.getTrans('Image upload failed. Maybe it is a problem with the file size. Please try again with selecting a file from your gallery or take a new photo using your front camera.')
        )
        this.isImageUploading = false;
      });
  }

  uploadImages(event) {
    const files = (event.target as HTMLInputElement).files;
    this.previewImage = files[0];
    

    const reader = new FileReader();
    reader.readAsDataURL(this.previewImage);
    reader.onload = () => {
      const image: any = new Image();
      image.src = reader.result;
      this.dynamic_url = image.src;
    };
  }

  async updateUserWithImageAndLocation(fileUrl) {
    return this.http
      .post(environment.baseUrl + 'games/updateUserWithImageAndLocation', {
        fileUrl,
        isCardContent: this.currentCardObj ? true : false,
        text: this.currentCardObj ? this.currentCardObj.title : this.imageComment,
        user: this.gameService?.me,
      })
      .subscribe((data: any) => {
        this.imageComment = null;

        if(this.currentCardObj){
         
          this.showNextCard();
          this.geoService.getUserByMe(this.route.snapshot.paramMap.get('p'));
          setTimeout(() => {
           this.getGameNotes();
          },1000);
          
        }


        this.dropNoty(
          'info',
          this.localeService.getTrans('Image successfully uploaded')
        );
      });
  }

  triggerDropCamcorder(currentCardObj?: any){
    if(this.currentCard.isDisabled || !this.isNotesImageCheck || this.isImageUploading){
      return;
    }
    
    this.dropCamcorder(currentCardObj);

  }

  dropCamcorder(currentCardObj?: any) {

    this.imageMessage = null;
    this.currentCardObj = currentCardObj || null;
  
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.setAttribute('capture', 'environment');
    input.style.display = 'none';

    console.log('Input created:', input);
  
    // Append to body to ensure it works on all browsers
    document.body.appendChild(input);
  
    input.addEventListener('change', (event: any) => {
      const files = (event.target as HTMLInputElement).files;
      console.log('Input change triggered', files);
  
      if (files && files.length > 0) {
        this.previewImage = files[0];
        console.log('Selected image:', this.previewImage);
  
        const reader = new FileReader();
  
        reader.onerror = (err) => {
          console.error('FileReader error', err);
          this.dropNoty('error', 'Image read failed.');
        };
  
        reader.onload = () => {
          console.log('FileReader onload triggered');
          setTimeout(() => {
            this.ngZone.run(() => {
              const result = reader.result as string;
              if (result && result.startsWith('data:image')) {
                this.dynamic_url = result;
                console.log('Opening camcorder modal');
                this.modalService.dismissAll();
                this.modalService.open(this.camCorderModal, { centered: true });
              } else {
                console.warn('Invalid image data:', result);
                this.dropNoty('error', 'Could not load image. Try again.');
              }
            });
          }, 800); // iOS needs extra time
        };
  
        reader.readAsDataURL(this.previewImage);
      } else {
        console.warn('No files selected');
      }
  
      // Cleanup
      input.remove();
    });
  
    input.click();
  }
  

  togglePerk(content, perk) {
    if (this.gameService.me.points < perk.points) {
      this.dropNoty(
        'info',
        this.localeService.getTrans(
          "You don't have enough points to use this perk."
        )
      );
    } else {
      let selectedPerk = perk;
      Swal.fire({
        imageUrl: './assets/images/v3/' + perk.type + '.svg',

        title: this.getPerkModalLocale(selectedPerk.type).title,
        text: this.getPerkModalLocale(selectedPerk.type).text,
        showDenyButton: false,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: this.localeService.getTrans(`Use perk`),
        confirmButtonColor: this.bgColor1,
        cancelButtonText: this.localeService.getTrans('Back'),
      }).then((result) => {
        if (result.isConfirmed) {
          if (selectedPerk.type === 'photo') {
            console.log('photo');
            this.previewImage = null;
            this.dynamic_url = null;
            this.dropCamcorder();
          } else {
            if (selectedPerk.type === 'freeze') {
              this.dropNoty(
                'info',
                this.getPerkModalLocale(selectedPerk.type).info
              );
              let players = _.filter(this.museumPlayers, (player) => {
                return player.name !== this.gameService.me.name;
              });
              if (!players.length) {
                this.dropNoty(
                  'info',
                  this.localeService.getTrans(
                    'No other players to use this perk on.'
                  )
                );
                return false;
              }
            } else if (selectedPerk.type === 'bomb') {
              let players = _.filter(this.museumPlayers, (player) => {
                return player.name !== this.gameService.me.name;
              });
              if (players.length) {
                selectedPerk.target =
                  players[Math.floor(Math.random() * players.length)].name;
                this.dropNoty(
                  'info',
                  this.getPerkModalLocale(selectedPerk.type).info
                );
              } else {
                this.dropNoty(
                  'info',
                  this.localeService.getTrans(
                    'No other players to use this perk on.'
                  )
                );
                return false;
              }
            } else if (selectedPerk.type === 'blank_map') {
              let players = _.filter(this.museumPlayers, (player) => {
                return player.name !== this.gameService.me.name;
              });
              if (!players.length) {
                this.dropNoty(
                  'info',
                  this.localeService.getTrans(
                    'No other players to use this perk on.'
                  )
                );
                return false;
              } else{
                this.dropNoty('info', this.localeService.getTrans('Splashed egg perk is active for 30 seconds.'));
              }
            } else if (selectedPerk.type === 'map_tap') {
              this.dropNoty(
                'info',
                this.getPerkModalLocale(selectedPerk.type).info
              );
            } else if (selectedPerk.type === 'text_input') {
              this.modalService.open(this.textInputModal, { centered: true });
            }
            // Deduct locally first so a stale getOtherPlayers poll cannot
            // briefly restore the pre-perk total while usePerk is in flight.
            const perkCost = Number(selectedPerk.points) || 0;
            if (perkCost > 0) {
              this.gameService.me.points = Math.max(
                0,
                (Number(this.gameService.me.points) || 0) - perkCost
              );
            }
            if (!Array.isArray(this.gameService.me.perkEvents)) {
              this.gameService.me.perkEvents = [];
            }
            this.gameService.me.perkEvents.push({
              type: selectedPerk.type,
              created: moment().unix(),
              createdBy: this.gameService.me._id,
              target: selectedPerk.target ? selectedPerk.target : null,
              isActive: true,
            });

            return this.http
              .post(environment.baseUrl + 'games/usePerk', {
                u: this.gameService.me._id,
                perk: selectedPerk,
                t: moment().unix(),
              })
              .subscribe((data: any) => {
                // Merge: usePerk returns the full user doc and used to wipe
                // local questionStatuses/answers when the server copy was empty.
                this.gameService.applyServerPlayer(data);
              });
          }
        }
      });
    }
  }

  getPerkModalLocale(type) {
    let locales = {
      freeze: {
        title: this.localeService.getTrans('Freeze'),
        text: this.localeService.getTrans(
          'You can freeze all players for 30 seconds'
        ),
        info: this.localeService.getTrans(
          'Freeze perk is active. You frozed all other players for 30 seconds.'
        ),
      },
      blank_map: {
        title: this.localeService.getTrans('Splashed egg'),
        text: this.localeService.getTrans(
          'A splashed egg is displayed to players, obscuring the map for 30 seconds.'
        ),
        info: this.localeService.getTrans(
          'Splashed egg perk is active for 30 seconds.'
        ),
      },
      photo: {
        title: this.localeService.getTrans('Photo gallery'),
        text: this.localeService.getTrans(
          'You can take photos during the game.'
        ),
        info: this.localeService.getTrans('You just activated the photo perk.'),
      },
      bomb: {
        title: this.localeService.getTrans('Bomb'),
        text: this.localeService.getTrans(
          'You can throw a bomb on a random player.'
        ),
        info: this.localeService.getTrans('You just activated the bomb perk.'),
      },
      map_tap: {
        title: this.localeService.getTrans('Map tap'),
        text: this.localeService.getTrans(
          'Simulate your position by tapping on the map.'
        ),
        info: this.localeService.getTrans(
          'Tap on the map to simulate your position and reach remote points for up to 30 seconds. Please wait 5 seconds after activating this perk before starting to tap.'
        ),
      },
      text_input: {
        title: this.localeService.getTrans('Text Input'),
        text: this.localeService.getTrans('Send message to Game host'), // TODO: change
        info: this.localeService.getTrans(
          'You can send message to the game master'
        ), // TODO: change
      },
    };

    return locales[type];
  }

  getPlayers() {
    this.geoService.getUserByTeamName(this.route.snapshot.paramMap.get('p'));
    /*   this.playerSynch = setInterval(() => {
      this.synchPlayers();
    }, 8000); */
    this.synchOtherPlayers();
    this.otherPlayerSynch = setInterval(() => {
      this.synchOtherPlayers();
      this.geoService.updateUserIfOK();
    }, 10000);

    setTimeout(() => {
      this.synchPlayers();
    }, 3000);

    /*   if(this.route.snapshot.paramMap.get('p') === 'admin-terminator'){
      this.otherPlayerSynch = setInterval(() => {
          this.geoService.updateUserStress();
          //this.ping();
      }, 1000);
    } */
  }
  removeMapComponent() {
    if (this.map) {
      this.map.destroy();
    }
  }
  endGameDirectly() {
    Swal.fire({
      title: this.localeService.getTrans('Do you really want to end the game?'),
      text: this.localeService.getTrans(
        "You cannot rejoin in the game if you hit 'End Game'"
      ),
      showDenyButton: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`End Game`),
      confirmButtonColor: this.bgColor1,
      cancelButtonText: this.localeService.getTrans('Back'),
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.geoLocationWatch) {
          navigator.geolocation.clearWatch(this.geoLocationWatch);
        }
        this.geoService.endGame('direct');
        //this.endGame('direct');
        //this.ping(1);
      }
    });
  }

  clearPhotoStorageAtEndOfGame() {
    localStorage.removeItem('validatedPhotoUrls-'+this.gameService.me._id);
  }

  endGame(reason) {
    this.clearIntervals();
    this.clearPhotoStorageAtEndOfGame();
    if (this.gameService.activeGame.isEndPOI) {
      this.doEndGame(reason);
    } else {
      this.doEndGame(reason);
    }
  }

  doEndGame(reason) {
    if (this.geoLocationWatch) {
      navigator.geolocation.clearWatch(this.geoLocationWatch);
    }
    this.clearIntervals();
    this.geoService.endGame(reason);
  }

  initIndoorMode(question) {
    this.geoService.questionDetected(question, true, this.activePerks);
  }
  toggleLevels() {
    if (
      this.activeLevel ===
      _.maxBy(this.gameService.activeGame.partner.raster_image_url, (x) => {
        return x.level;
      }).level
    ) {
      this.activeLevel = 1;
    } else {
      this.activeLevel = this.activeLevel + 1;
    }
    this.setLevels(this.activeLevel);
  }
  setLevels(level) {
    const filteredLayers = _.filter(
      this.gameService.activeGame.partner.raster_image_url,
      (x) => {
        return x.level === level;
      }
    );
    
    // Convert coordinates from [lat, lng] to [lng, lat] format for mapbox
    this.activeLayers = filteredLayers.map(layer => {
      const convertedCoords = layer.coordinates.map(coord => [coord[1], coord[0]]);
      console.log('Original coordinates:', layer.coordinates);
      console.log('Converted coordinates:', convertedCoords);
      return {
        ...layer,
        coordinates: convertedCoords
      };
    });
    
    console.log('Active layers set:', this.activeLayers);
  }

  scanQR() {
    this.pageConfig.showQrReader = true;
    this.changeDetectorRef.detectChanges();
    this.scanner.camerasFound.subscribe((devices: MediaDeviceInfo[]) => {
      this.hasDevices = true;
      this.availableDevices = devices;

      // selects the devices's back camera by default
      for (const device of devices) {
        if (/back|rear|environment/gi.test(device.label)) {
          this.scanner.isCurrentDevice(device);
          this.currentDevice = device;
          break;
        }
      }
    });

    this.scanner.camerasNotFound.subscribe(() => (this.hasDevices = false));
    this.scanner.permissionResponse.subscribe(
      (perm: boolean) => (this.hasPermission = perm)
    );
  }

  


  handleQrCodeResult(resultString: string) {
    this.closeQR();

    let str = resultString.substr(
      resultString.indexOf('&qId=') + 5,
      resultString.length
    );
    str = str.split('&')[0];


    if (resultString && str) {
      let question = _.find(this.gameService.activeGame.quests, (q) => {
        return q._id == str;
      });

      if (question) {
        this.geoService.questionDetected(question, null, this.activePerks);
      } else {
        this.utilsService.dropSwal(
          this.localeService.getTrans('Uh oh'),
          this.localeService.getTrans(
            'This QR code has been activated already'
          ),
          'info',
          this.localeService.getTrans('Got it'),
        );
      }
    }
  }

  closeQR() {
    this.pageConfig.showQrReader = false;
    if (this.scanner) {
      this.scanner.scanStop();
    }
  }

  sendTextInput() {
    this.modalService.dismissAll();
    console.log(this.textInputValue, 'input');
    if (this.textInputValue) {
      this.http
        .post(environment.baseUrl + 'games/sendTextInput', {
          text: this.textInputValue,
          player: this.gameService.me,
          gameId: this.gameService.activeGame._id,
        })
        .subscribe((data: any) => {
          this.textInputValue = '';
          this.dropNoty('success', this.localeService.getTrans('Text snippet sent'));
         
        });
    }
  }

  getGameNotes(isPolling = false) {
    return this.http.post(environment.baseUrl + `games/getGameNotes`,  {groupId: this.gameService.activeGame.groupId}).subscribe((res: any) => {
      if(res.tourId && res.tourId.notes){
        if(res.notes.length !== this.gameNotes.length && this.firstGameNoteRun === false){
          this.dropNoty('info', this.localeService.getTrans('New game card available!'));
        }

        res.notes = res.notes.map((note) => {

          let isDisabled = false;

          console.log(this.gameService.me)

          if(this.gameService.me && this.gameService.me.photos){
            const photo = _.find(this.gameService.me.photos, (p) => {
              return p.isCardContent && p.text === note.title;
            });

            if(photo){
              isDisabled = true;

              if(this.currentCard && this.currentCard.title === note.title){
                this.currentCard.isDisabled = true;
              }
            }

            this.isNotesImageCheck = true;

          }

          return {
            ...note,
            ...{
             isDisabled
            }
          };
        });

        this.gameNotes = [...res.notes];
        console.log(this.gameNotes, 'game notes');
       


        if(this.firstGameNoteRun){
          this.currentCard = this.gameNotes[this.currentCardIndex];
        } 
        
        this.firstGameNoteRun = false;
        
        if(isPolling){
          setTimeout(() => {
            this.getGameNotes(isPolling);
          },10000);
        }

      }
       

    });
}

showNextCard() {
  if (this.gameNotes.length > 0 && !this.isImageUploading) {
    if(this.currentCardIndex +1 >= this.gameNotes.length){
      this.currentCardIndex = 0;
      this.currentCard = this.gameNotes[this.currentCardIndex];
    } else{
      this.currentCardIndex++;
      this.currentCard = this.gameNotes[this.currentCardIndex];
    }
   
   
  }
}

  getGame(gameId, player, isInit?) {
    return this.http
      .post(environment.baseUrl + 'games/getGame', { gameId, player })
      .subscribe((data: any) => {
        if (data.success) {
          this.gameService.activeGame = data.data;

          if(this.gameService.activeGame.isNotesEnabled){
            this.getGameNotes(true);
          }


         

       
          console.log(this.gameService.activeGame);
          
          if (data.data.isFinished) {
            this.router.navigate(['/review'])
            // this.router.navigate([
            //   '/endGame',
            //   {
            //     c: 'direct',
            //     g: this.route.snapshot.paramMap.get('g'),
            //     p: this.route.snapshot.paramMap.get('p'),
            //     groupId: this.gameService.activeGame.groupId,
            //   },
            // ]);
          } else {
            if (data.data.partner) {
              this.gameService.isPartnerGame = true;
              this.pageConfig.initialQuestion = true;
            }
          
            console.log(this.gameService.activeGame.tourId.style.mapStyle)
            this.mapStyle = this.gameService.activeGame.tourId.style.mapStyle;

            this.bgColor1 = this.utilsService.resolveBrandColor(
              this.gameService.activeGame.partner,
              this.gameService.activeGame.tourId
            );

            if (
              this.route.snapshot.paramMap.get('showcase') === 'true'
            ) {
              this.pageConfig.showcaseIsActive = true;
            }

            this.localeService.locale = this.gameService.activeGame.tourId
              .locale
              ? this.gameService.activeGame.tourId.locale
              : 'en';
              
              
              if (
                this.gameService.activeGame.partner.raster_image_url &&
                this.gameService.activeGame.partner.raster_image_url.length > 0
                ) {
                  this.setLevels(1);
                  
                  // Use raster image coordinates for bounds
                  if (this.gameService.activeGame.partner.raster_image_url[0].coordinates) {
                    const coords = this.gameService.activeGame.partner.raster_image_url[0].coordinates;
                    // Convert from [lat, lng] to [lng, lat] format for mapbox
                    this.activeBounds = [
                      [coords[0][1], coords[0][0]],  // [lng, lat] from first corner
                      [coords[2][1], coords[2][0]]   // [lng, lat] from third corner
                    ];
                  }
            } else {
              console.log('no raster image');
              
              // Calculate bounds based on available quests
              if (this.gameService.activeGame.quests && this.gameService.activeGame.quests.length > 0) {
                if (this.gameService.activeGame.quests.length >= 2) {
                  // Use first two quests
                  this.activeBounds = [
                    [
                      this.gameService.activeGame.quests[0].lng,
                      this.gameService.activeGame.quests[0].lat,
                    ],
                    [
                      this.gameService.activeGame.quests[1].lng,
                      this.gameService.activeGame.quests[1].lat,
                    ],
                  ];
                } else {
                  // Only one quest - create bounds with padding
                  const quest = this.gameService.activeGame.quests[0];
                  const padding = 0.002; // ~200m padding
                  this.activeBounds = [
                    [quest.lng - padding, quest.lat - padding],
                    [quest.lng + padding, quest.lat + padding],
                  ];
                }
              }
            }
            
            this.gameService.originalQuests = data.data.quests;
            //this.gameService.activeGame.quests = data.data.quests;

            if (!this.gameService.activeGame.indoorMode) {
              this.getPlayers();
              this.initGame();
            } else {
              this.getPlayers();
            }

            setTimeout(() => {
              this.colorize();
            }, 1000);

            if (data.data.tourId.isGameTimer) {
              console.log("bejött")
              this.startGameCountdown();
            } else {
              this.terminateGameDueInactivity();
              console.log("Kiment")
            }
          }
        } else {
          console.log("big else")
          this.navigateBack();
        }
      });
  }

  navigateBack() {
    this.router.navigate(['/']);
  }

  ngOnInit() {
    if (this.utilsService.checkDeviceCompatibility()) {
      this.clearIntervals();
    }
  }

  ngAfterViewInit() {}
}